import { TMutation, TQuery } from 'app/Requests/types';
import httpDriver from 'app/utils/httpDriver';
import { influencerApiRoutes, entitiesApiRoutes } from '../utils/apiRoutes';
import { apiRoutes as TweetsApiRoutes } from 'tweets/utils/apiRoutes';
import {
  handleCalenderColors,
  newhandleCalenderColors,
} from 'influencers/utils/getModuleName';
import { checkTranslated } from 'app/utils/helpers';

export const getParentCategories = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1].slug, { limit: 500 });
  return data.payload?.records.map((cat: any) => ({
    label: cat.name,
    value: cat.id,
  }));
};

export const attachToParentCategory = async ({
  body,
  slug,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(slug, body);
  return data;
};

export const mergeAction = async ({
  body,
  slug,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(slug, body);
  return data;
};

export const regrabGroup = async (body: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    body?.isInfluencerModule
      ? influencerApiRoutes().regrabGroup
      : entitiesApiRoutes().regrabGroup,
    body,
  );
  return data;
};

export const loadInfluencerDetails = async ({
  id,
  isInfluencerModule,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().influencerDetails
      : entitiesApiRoutes().influencerDetails,
    { influencer_id: +id },
  );
  return data?.payload?.records;
};

export const getEmploymentTypes = async (): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().employmentTypes,
    {},
  );
  return data?.payload?.records;
};
export const getEducationDegree = async (): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().educationDegree,
    {},
  );
  return data?.payload?.records;
};
export const getClassification = async ({ queryKey }: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().LinkedClassifications
      : entitiesApiRoutes().LinkedClassifications,
    {},
  );
  return data?.payload?.records;
};
export const getClassificationInsta = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().instagramClassifications
      : entitiesApiRoutes().instagramClassifications,
    {},
  );
  return data?.payload?.records;
};
export const getMediaTypesInsta = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().instagramMediaTypes
      : entitiesApiRoutes().instagramMediaTypes,
    {},
  );
  return data?.payload?.records;
};

export const getSorting = async ({ queryKey }: TQuery): Promise<any> => {
  const { isInfluencerModule, tabName, isPostTwitter } = queryKey[1];
  console.log(tabName, 'queryKey[2]');

  const currentApi =
    tabName === 'TWEETS' || tabName === 'QUOTES' || tabName === 'REPLIES'
      ? entitiesApiRoutes().twitterSorting
      : tabName === 'VIDEOS'
        ? entitiesApiRoutes().videosSorting
        : tabName === 'POSTS_INSTA'
          ? entitiesApiRoutes().instagramSorting
          : tabName === 'TIKTOK'
            ? isInfluencerModule
              ? influencerApiRoutes().tiktokSorting
              : entitiesApiRoutes().tiktokSorting
            : entitiesApiRoutes().linkedinSorting;

  const { data } = await httpDriver.post(currentApi, {});
  return data?.payload?.records;
};
export const convertInfluencer = async ({
  id,
  isInfluencerModule,
}: TMutation<{ id: string; isInfluencerModule: boolean }>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().convertInfluencer
      : entitiesApiRoutes().convertInfluencer,
    { influencer_id: +id },
  );
  return data?.payload?.records;
};

export const storeInfluencerName = async ({
  username,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().storeInfluencerName,
    { username: username },
  );
  return data?.payload;
};
export const storeInfluencerSentiment = async ({
  words,
  category,
  influencer_id,
}: TMutation<{
  words: string[];
  category: string;
  influencer_id: number;
}>): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().storeInfluencerSentiment,
    { words, category, influencer_id },
  );
  return data;
};

export const storeInfluencerYoutuber = async ({
  remote_id,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().storeInfluencerYoutuber,
    { remote_id: remote_id },
  );
  return data?.payload;
};

export const storeInfluencerAsLinkedin = async ({
  username,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().storeInfluencerAsLinkedIn,
    { username: username },
  );
  return data?.payload;
};
export const getCardData = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1].slug, queryKey[1].body);
  return {
    count:
      data?.payload?.records?.count || data?.payload?.records?.last_post_time,
    newCount: data?.payload?.records?.new_count,
  };
};
export const loadLocationHistory = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { body, isInfluencerModule } = queryKey[1];

  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().influencerLocationHistory
      : entitiesApiRoutes().influencerLocationHistory,
    body,
  );
  return data?.payload?.records;
};

export const loadListContent = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1].slug, queryKey[1].body);
  return data?.payload;
};

export const getAgeGroup = async ({ queryKey }: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().allAgeGroup
      : entitiesApiRoutes().allAgeGroup,
    {},
  );
  return data?.payload?.records;
};

export const getIndustriesOrReligions = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().religions
      : entitiesApiRoutes().industries,
    {},
  );
  return data?.payload?.records;
};

export const loadCalendarData = async ({ queryKey }: TQuery): Promise<any> => {
  const { body, slug, isInfluencerModule } = queryKey[1];

  const { data } = await httpDriver.post(
    `${isInfluencerModule ? 'influencers' : 'entities'}/${slug}`,
    body,
  );
  const dates = data?.payload?.records.map((el: any, index: any) => {
    return {
      id: index,
      start: el.key,
      value: el.value,
      display: 'background',
    };
  });

  return handleCalenderColors(dates);
};
export const loadAuthorCalendarData = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { body, slug } = queryKey[1];
  const { data } = await httpDriver.post(slug, body);
  const dates = data?.payload?.records.map((date: any, index: number) => {
    return {
      id: index,
      start: date.key,
      value: date.value,
      display: 'background',
    };
  });

  return newhandleCalenderColors(dates);
};

export const getAnalyzedOpts = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1], { limit: 50 });
  return data?.payload?.records.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));
};

export const getTwitterAnalyzedTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().twitterAnalyzedTab
      : entitiesApiRoutes().twitterAnalyzedTab,
    body,
  );
  return data?.payload?.records;
};

export const loadInfluencerGrabbingStatus = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().influencerGrabbingStatus
      : entitiesApiRoutes().entityGrabbingStatus,
    body,
  );
  return data.payload;
};

export const changeInfluencerTweetType = async ({
  body,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().changeTweetType
      : entitiesApiRoutes().changeTweetType,
    body,
  );
  return data;
};

export const changeNewsType = async ({
  body,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().changeNewsType
      : entitiesApiRoutes().changeNewsType,
    body,
  );
  return data;
};

export const loadByMonthTab = async ({ queryKey }: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().twitterTweetsTabByMonth
      : entitiesApiRoutes().twitterTweetsTabByMonth,
    body,
  );
  return data?.payload?.records;
};

export const loadRelatedChannel = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().youtubeVideosTabFeaturing
      : entitiesApiRoutes().youtubeVideosTabFeaturing,
    body,
  );
  return data?.payload?.records;
};

export const loadYoutubeAnalyzeTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, influencer_id, channel_id, is_sample } =
    queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().youtubeAnalyzeTab
      : entitiesApiRoutes().youtubeAnalyzeTab,
    { influencer_id, channel_id, limit: 5, is_sample },
  );
  return data?.payload?.records;
};

export const changeInfluencerVideoType = async ({
  body,
  isInfluencerModule,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().changeVideoType
      : entitiesApiRoutes().changeVideoType,
    body,
  );
  return data;
};
export const changeInfluencerTiktokVideoType = async ({
  body,
  isInfluencerModule,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().tiktokChangeVideoType
      : entitiesApiRoutes().tiktokChangeVideoType,
    body,
  );
  return data;
};
export const changeLinkedinPostCategory = async ({
  body,
  isInfluencerModule,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().changePostCategory
      : entitiesApiRoutes().changePostCategory,

    body,
  );
  return data;
};

export const youtubeLoadByMonthTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().youtubeVideosTabByMonth
      : entitiesApiRoutes().youtubeVideosTabByMonth,
    body,
  );
  return data?.payload?.records;
};
export const tiktokLoadByMonthTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().tiktokVideosByMonthTab
      : entitiesApiRoutes().tiktokVideosByMonthTab,
    body,
  );
  return data?.payload?.records;
};
export const linkedinLoadByMonthTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().linkedinPostsTabByMonth
      : entitiesApiRoutes().linkedinPostsTabByMonth,
    body,
  );
  return data?.payload?.records;
};

export const editGroup = async ({
  body,
  isInfluencerModule,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.put(
    isInfluencerModule
      ? influencerApiRoutes().editGroup
      : entitiesApiRoutes().editGroup,
    body,
  );
  return data;
};

export const addNewGroup = async ({
  body,
  isInfluencerModule,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().addNewGroup
      : entitiesApiRoutes().addNewGroup,
    body,
  );
  return data;
};

export const getGroupData = async ({
  isInfluencerModule,
  id,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().getGroupData
      : entitiesApiRoutes().getGroupData,
    { group_id: +id },
  );
  return data;
};

export const addNewInfluencer = async ({
  isInfluencerModule,
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().addNewInfluencer
      : entitiesApiRoutes().addNewInfluencer,
    body,
  );
  return data;
};

export const editInfluencer = async ({
  isInfluencerModule,
  body,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.put(
    isInfluencerModule
      ? influencerApiRoutes().editInfluencer
      : entitiesApiRoutes().editInfluencer,
    body,
  );
  return data;
};

export const loadAnalyzedInfluencerDetails = async ({
  isInfluencerModule,
  id,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().analyzedInfluencerDetails
      : entitiesApiRoutes().analyzedInfluencerDetails,
    { influencer_id: +id },
  );
  return data?.payload?.records;
};
export const loadEducations = async ({
  isInfluencerModule,
  id,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().allEducations
      : entitiesApiRoutes().allEducations,
    { influencer_id: +id },
  );
  return data?.payload?.records;
};

export const resyncInfluencer = async ({
  isInfluencerModule,
  id,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().resyncInfluencer
      : entitiesApiRoutes().resyncInfluencer,
    { influencer_id: +id },
  );
  return data?.payload?.records;
};
export const getInfluncerPlatforms = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];

  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().influncersPlatforms
      : entitiesApiRoutes().entityPlatforms,
  );
  return (
    data?.payload?.records.map((opt: any) => {
      return { value: opt.id, label: opt.name };
    }) || []
  );
};
export const getInfluncerProfileStatus = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];

  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().influncersPlatformsStatuses
      : entitiesApiRoutes().entityPlatformsStatuses,
  );

  return (
    data?.payload?.records.map((opt: any) => {
      return { value: opt.key, label: checkTranslated(opt.name, opt.name_ar) };
    }) || []
  );
};

export const handleGetCategoriesOpts = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().getCategories
      : entitiesApiRoutes().getCategories,
    { limit: 50 },
  );
  return data?.payload?.records?.map((item: any) => ({
    label: item?.label,
    value: item?.value,
  }));
};

export const handleGetGroupsOpts = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().activeGroups
      : entitiesApiRoutes().activeGroups,
    { limit: 20 },
  );
  return data?.payload?.records?.map((item: any) => ({
    label: item?.label,
    value: item?.value,
  }));
};

export const trashInfluencer = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().trashInfluencer
      : entitiesApiRoutes().trashInfluencer,
    { ids: [+id] },
  );
  return { ...data, successMessage };
};

export const importantInfluencer = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().importantInfluencer
      : entitiesApiRoutes().importantInfluencer,
    { ids: [+id] },
  );
  return { ...data, successMessage };
};
export const grabSingleInfluencer = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().resyncInfluencer
      : entitiesApiRoutes().resyncInfluencer,
    {
      influencer_id: id,
    },
  );
  return { ...data, successMessage };
};
export const grabAllOldTweets = async ({
  isInfluencerModule,
  id,
}: // successMessage,

TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().regrabAllOldTweet
      : entitiesApiRoutes().regrabAllOldTweet,
    {
      influencer_id: id,
    },
  );
  return { ...data };
};
export const grabDetails = async ({
  isInfluencerModule,
  id,
  checkPlatformName,
  socialMediaId,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().regrabDetails
      : entitiesApiRoutes().regrabDetails,
    {
      influencer_id: id,
      [checkPlatformName as string]: [socialMediaId],
    },
  );
  return { ...data };
};
export const allGrabDetails = async ({
  isInfluencerModule,
  id,
  linkedin,
  tweet,
  youtube,
  instagram,
  tiktok,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().regrabDetails
      : entitiesApiRoutes().regrabDetails,
    {
      influencer_id: id,
      linkedin_profile_id: linkedin,
      channel_ids: youtube,
      twitter_profile_ids: tweet,
      instagram_profile_ids: instagram,
      tiktok_profile_ids: tiktok,
    },
  );
  return { ...data };
};
export const unimportantInfluencer = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().unimportantInfluencer
      : entitiesApiRoutes().unimportantInfluencer,
    { ids: [+id] },
  );
  return { ...data, successMessage };
};

export const makeAnalyzeInfluencer = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().analyzeInfluencer
      : entitiesApiRoutes().analyzeInfluencer,
    { influencer_id: id },
  );
  return { ...data, successMessage };
};

export const deleteInfluencer = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.delete(
    isInfluencerModule
      ? influencerApiRoutes().deleteInfluencer
      : entitiesApiRoutes().deleteInfluencer,
    { data: { ids: [+id] } },
  );
  return { ...data, successMessage };
};

export const restoreInfluencer = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().restoreInfluencer
      : entitiesApiRoutes().restoreInfluencer,
    { ids: [+id] },
  );
  return { ...data, successMessage };
};

export const deleteCategory = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.delete(
    isInfluencerModule
      ? influencerApiRoutes().deleteCategory
      : entitiesApiRoutes().deleteCategory,
    { data: { ids: [+id] } },
  );
  return { ...data, successMessage };
};

export const trashCategory = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().trashCategory
      : entitiesApiRoutes().trashCategory,
    { ids: [+id] },
  );
  return { ...data, successMessage };
};

export const restoreCategory = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().restoreCategory
      : entitiesApiRoutes().restoreCategory,
    { ids: [+id] },
  );
  return { ...data, successMessage };
};

export const getParentCategoriesInfluencer = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().getParentCategories
      : entitiesApiRoutes().getParentCategories,
    { limit: 500 },
  );
  return data?.payload?.records?.map((cat: any) => ({
    label: cat.name,
    value: cat.id,
  }));
};

export const deleteGroup = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.delete(
    isInfluencerModule
      ? influencerApiRoutes().deleteGroup
      : entitiesApiRoutes().deleteGroup,
    { data: { ids: [+id] } },
  );
  return { ...data, successMessage };
};

export const restoreGroup = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().restoreGroup
      : entitiesApiRoutes().restoreGroup,
    { ids: [+id] },
  );
  return { ...data, successMessage };
};

export const trashGroup = async ({
  isInfluencerModule,
  id,
  successMessage,
}: TMutation<any>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().trashGroup
      : entitiesApiRoutes().trashGroup,
    { ids: [+id] },
  );
  return { ...data, successMessage };
};
// export const getMostFrequentWords = async ({
//   isInfluencerModule,
//   id,
// }: TMutation<any>): Promise<any> => {
//   const { data } = await httpDriver.post(
//     isInfluencerModule
//       ? influencerApiRoutes().mostFrequentWords
//       : entitiesApiRoutes().mostFrequentWords,
//     { influencer_id: +id }
//   );
//   return { ...data };
// };

export const getMostFrequentWords = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    queryKey[1]
      ? influencerApiRoutes().mostFrequentWords
      : entitiesApiRoutes().mostFrequentWords,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getMostFrequentHashtags = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    queryKey[1]
      ? influencerApiRoutes().mostFrequentHashtags
      : entitiesApiRoutes().mostFrequentHashtags,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getColumnsSentimentData = async ({
  isInfluencerModule,
  id,
  type,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().influencerColumnSentiment
      : entitiesApiRoutes().influencerColumnSentiment,
    {
      category: type,
      influencer_id: Number(id),
    },
  );
  return data?.payload?.records;
};

export const getHashtagsDataForGroup = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1], queryKey[2]);
  return data.payload.records;
};
export const getAuthorByMonth = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    queryKey[1]
      ? influencerApiRoutes().newsTabByMonth
      : entitiesApiRoutes().newsTabByMonth,
    queryKey[2],
  );
  return data?.payload?.records;
};
export const getTweetTypes = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    queryKey[1]
      ? influencerApiRoutes().tweetTypes
      : entitiesApiRoutes().tweetTypes,
  );
  return (
    data?.payload?.records.map((opt: any) => {
      return {
        value: opt.value,
        label: checkTranslated(opt?.name, opt?.name_ar),
      };
    }) || []
  );
};

export const getNationalityStatuses = async (): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().getNationalityStauses,
  );
  return data?.payload?.records || [];
};
export const getAuthorCalnder = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(queryKey[1], queryKey[2]);
  return data?.payload?.records || [];
};

export const getGroupDetails = async ({ queryKey }: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    queryKey[1].isInfluencerModule
      ? influencerApiRoutes().getGroupData
      : entitiesApiRoutes().getGroupData,
    queryKey[1].body,
  );
  return data?.payload?.records;
};
export const getInfInfoTypesOptions = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { data } = await httpDriver.post(
    queryKey[1].isInfluencerModule
      ? influencerApiRoutes().infInfoOptions
      : entitiesApiRoutes().infInfoOptions,
  );
  return data?.payload?.records || [];
};
export const updateSentimentAnalysis = async ({
  isInfluencerModule,
  id,
  sets,
  words,
  hashtags,
}: TMutation): Promise<any> => {
  const { data } = await httpDriver.put(
    isInfluencerModule
      ? influencerApiRoutes().updateSentimentAnalysis
      : entitiesApiRoutes().updateSentimentAnalysis,
    {
      influencer_id: Number(id),
      sets,
      words,
      hashtags,
    },
  );
  return data;
};
export const influencerRelationOptions = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { influencer_id, isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().influencerRelationOptions
      : entitiesApiRoutes().entityRelationOptions,
    { influencer_id },
  );
  return data?.payload;
};
export const unlinkRelativeRelatedInfluencers = async ({
  id,
  influencer_id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().unlinkRelativesRelatedInfluencers,
    {
      influencer_id,
      ids: [id],
    },
  );
  return { ...data, successMessage };
};
export const unlinkFriendRelatedInfluencers = async ({
  id,
  influencer_id,
  successMessage,
}: TMutation<number>): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().unlinkFriendsRelatedInfluencers,
    {
      influencer_id,
      ids: [id],
    },
  );
  return { ...data, successMessage };
};
export const getRelatedInfluencers = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { influencer_id, isInfluencerModule, limit } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().allRelatedInfluencers
      : entitiesApiRoutes().allRelatedInfluencers,
    { influencer_id, limit },
  );
  return data?.payload;
};

export const getRelatedEntities = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { influencer_id, isInfluencerModule, limit } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().allRelatedEntities
      : entitiesApiRoutes().allRelatedEntities,
    { influencer_id, limit },
  );
  return data?.payload;
};

export const getReportInfCount = async ({ queryKey }: TQuery): Promise<any> => {
  const { body, isInfluencerModule } = queryKey[1];

  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().getReportInfCount
      : entitiesApiRoutes().getReportEntitiesCount,
    body,
  );
  return data?.payload?.records.count;
};

export const suspendTwitterProfile = async (body: TMutation): Promise<any> => {
  const { isInfluencerModule, ...rest } = body;
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().suspendTwitter
      : entitiesApiRoutes().suspendTwitter,
    rest,
  );
  return data;
};

export const regrabFollowingTwitter = async ({
  influencer_id,
  twitter_profile_id,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().twitterRegrabFollowing
      : entitiesApiRoutes().twitterRegrabFollowing,
    { influencer_id, twitter_profile_id },
  );
  return data?.payload;
};

export const regrabFollowersTwitter = async ({
  influencer_id,
  twitter_profile_id,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().twitterRegrabFollowers
      : entitiesApiRoutes().twitterRegrabFollowers,
    { influencer_id, twitter_profile_id },
  );
  return data?.payload;
};
export const regrabFollowersTiktok = async ({
  influencer_id,
  tiktok_profile_id,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().tiktokRegrabFollowersTab
      : entitiesApiRoutes().tiktokRegrabFollowersTab,
    { influencer_id, tiktok_profile_id },
  );
  return data?.payload;
};
export const regrabFollowingTiktok = async ({
  influencer_id,
  tiktok_profile_id,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().tiktokRegrabFollowingTab
      : entitiesApiRoutes().tiktokRegrabFollowingTab,
    { influencer_id, tiktok_profile_id },
  );
  return data?.payload;
};

export const suspendInstagramProfile = async (
  body: TMutation,
): Promise<any> => {
  const { isInfluencerModule, ...rest } = body;
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().instagramProfileSuspend
      : entitiesApiRoutes().instagramProfileSuspend,
    rest,
  );
  return data;
};
export const suspendTiktokProfile = async (body: TMutation): Promise<any> => {
  const { isInfluencerModule, ...rest } = body;
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().tiktokSuspendProfile
      : entitiesApiRoutes().tiktokSuspendProfile,
    rest,
  );
  return data;
};

export const activateTwitterProfile = async (body: TMutation): Promise<any> => {
  const { isInfluencerModule, ...rest } = body;

  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().activateTwitter
      : entitiesApiRoutes().activateTwitter,
    rest,
  );

  return data;
};
export const activateTiktokProfile = async (body: TMutation): Promise<any> => {
  const { isInfluencerModule, ...rest } = body;

  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().tiktokActivateProfile
      : entitiesApiRoutes().tiktokActivateProfile,
    rest,
  );

  return data;
};

export const activateInstagramProfile = async (
  body: TMutation,
): Promise<any> => {
  const { isInfluencerModule, ...rest } = body;

  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().instagramProfileActive
      : entitiesApiRoutes().instagramProfileActive,
    rest,
  );

  return data;
};

export const regrabEmployees = async (body: TMutation): Promise<any> => {
  const { isInfluencerModule, ...rest } = body;

  const { data } = await httpDriver.post(
    entitiesApiRoutes().LinkedEmployeesRegrab,
    rest,
  );

  return data;
};
export const loadLinkedInAnalyzeTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { influencer_id, isInfluencerModule, linkedin_profile_id, is_sample } =
    queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().linkedAnalyzedTab
      : entitiesApiRoutes().linkedAnalyzedTab,
    { influencer_id, linkedin_profile_id, limit: 5, is_sample },
  );
  return data?.payload?.records;
};

export const getInstagramAnalyzedTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().instagramAnalyzedTab
      : entitiesApiRoutes().instagramAnalyzedTab,
    body,
  );
  return data?.payload?.records;
};

export const storeInfluencerInstagram = async ({
  username,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().storeInfluencerInstagram,
    { username: username },
  );
  return data?.payload;
};

export const regrabFollowersInstagram = async ({
  influencer_id,
  instagram_profile_id,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().instagramRegrabFollowers
      : entitiesApiRoutes().instagramRegrabFollowers,
    { influencer_id, instagram_profile_id },
  );
  return data?.payload;
};

export const regrabFollowingInstagram = async ({
  influencer_id,
  instagram_profile_id,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().instagramRegrabFollowing
      : entitiesApiRoutes().instagramRegrabFollowing,
    { influencer_id, instagram_profile_id },
  );
  return data?.payload;
};

export const loadInstagramByMonthTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, body } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().instagramPostsTabByMonth
      : entitiesApiRoutes().instagramPostsTabByMonth,
    body,
  );
  return data?.payload?.records;
};

export const changeInfluencerInstagramPostType = async ({
  body,
  isInfluencerModule,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().changeInstagramPostType
      : entitiesApiRoutes().changeInstagramPostType,
    body,
  );
  return data;
};
export const loadTiktokAnalyzeTab = async ({
  queryKey,
}: TQuery): Promise<any> => {
  const { isInfluencerModule, influencer_id, tiktok_profile_id, is_sample } =
    queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().tiktokAnalyzedTab
      : entitiesApiRoutes().tiktokAnalyzedTab,
    { influencer_id, tiktok_profile_id, limit: 5, is_sample },
  );
  return data?.payload?.records;
};
export const storeInfluencerAsTiktok = async ({
  username,
}: TMutation<string>): Promise<any> => {
  const { data } = await httpDriver.post(
    influencerApiRoutes().storeInfluencerTiktok,
    { username: username },
  );
  return data?.payload;
};

export const getTiktokSorting = async ({ queryKey }: TQuery): Promise<any> => {
  const { isInfluencerModule } = queryKey[1];
  const { data } = await httpDriver.post(
    isInfluencerModule
      ? influencerApiRoutes().tiktokSorting
      : entitiesApiRoutes().tiktokSorting,
    {},
  );
  return data?.payload?.records;
};
